import { inject } from 'vue';

/**
 * Access utility functions to make working with Uppy easier.
 *
 * @returns {{
 *  getUploadAPIEndpoint: () => string
 *  getUppyLocale: () => object
 * }}
 */
export default function useUppyUtils() {
  const $bct = inject('translator');

  function getUppyLocale() {
    return {
      strings: {
        addingMoreFiles: $bct('Adding more files'),
        addMore: $bct('Add more'),
        addMoreFiles: $bct('Add more files'),
        back: $bct('Back'),
        browseFiles: $bct('Drop files here or browse files'),
        browseFolders: $bct('Drop files here or browse folders'),
        cancel: $bct('Cancel'),
        cancelUpload: $bct('Cancel upload'),
        complete: $bct('Complete'),
        done: $bct('Done'),
        dropHint: $bct('Drop your files here'),
        dropPasteBoth: $bct('%{browseFiles} ', {
          browseFiles: $bct('%{browseFiles}'),
        }),
        dropPasteFiles: $bct('%{browseFiles} ', {
          browseFiles: $bct('%{browseFiles}'),
        }),
        dropPasteFolders: $bct('%{browseFolders} ', {
          browseFiles: $bct('%{browseFolders}'),
        }),
        removeFile: $bct('Remove file'),
        save: $bct('Save'),
        uploadComplete: $bct('Upload complete'),
        uploadXFiles: {
          0: $bct('Upload %{smart_count} file'),
          1: $bct('Upload %{smart_count} files'),
        },
        uploadingXFiles: {
          0: $bct('Uploading %{smart_count} file'),
          1: $bct('Uploading %{smart_count} files'),
        },
        xFilesSelected: {
          0: $bct('%{smart_count} file selected'),
          1: $bct('%{smart_count} files selected'),
        },
      },
    };
  }

  return {
    getUploadAPIEndpoint,
    getUppyLocale,
  };
}

function getUploadAPIEndpoint() {
  const path = 'attachments/upload';
  return [window.api_url, path].join('/');
}
